/** Modal IDs that allow GNB/footer interaction while open (see useFocusTrap allowedOutsideSelectors). */
export const MODAL_IDS = {
    NAVIGATION_GUIDE: 'navigation-guide-modal',
    NEARBY_POI_LIST: 'nearby-poi-list-dropdown-modal',
} as const;

const MODALS_ALLOWING_GNB_FOOTER_INTERACTION = new Set<string>(Object.values(MODAL_IDS));

export const blocksGlobalKeypadForModalStack = (modalStack: readonly string[]): boolean => {
    if (modalStack.length === 0) {
        return false;
    }

    const topModal = modalStack[modalStack.length - 1];
    return !MODALS_ALLOWING_GNB_FOOTER_INTERACTION.has(topModal);
};
